import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';


class RelatedBulkUploadRecord extends Component {

//TODO: Duplicated with WFMI
  getDateString = (value) =>
  {
    return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
    return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    const record = this.props.record;

    const tableRows = [
      ["Bulk Upload ID", record.BulkUploadID, "Local Incident ID", record.LocalIncidentID],
      ["Fire Discovery Date", record.FireDiscoveryDate, "Fire Discovery Time", record.FireDiscoveryTime],
      ["Fire Reporting Agency Unit Identifier", record.FireReportingAgencyUnitIdentifier, "State", record.State],
      ["Latitude", record.Latitude, "Longitude", record.Longitude],
      ["Statistical Cause Code", record.StatisticalCauseCode, "Final Fire Acre Quantity", record.FinalFireAcreQuantity],
      ["Fire Containment Date", record.FireContainmentDate, "Fire Containment Time", record.FireContainmentTime],
      ["Incident Name", record.IncidentName, "State FIPS", record.StateFIPS],
      ["County", record.County, "County FIPS", record.CountyFIPS],
      ["District", record.District, "Ownership Code", record.OwnershipCode],
      ["Residences Threatened", record.ResidencesThreatened, "Residences Destroyed", record.ResidencesDestroyed],
      ["Fire Department ID", record.FireDepartmentID, "Fire Discovery Date", record.FireDiscoveryDateTime],
      ["Other Structures Threatened", record.OtherStructuresThreatened, "Other Structures Destroyed", record.OtherStructuresDestroyed],
      ["Number Injuries", record.NumberInjuries, "Number Fatalities", record.NumberFatalities],
    ];

    return (
      <Paper elevation={3}>
      <Table size="small">
        <TableBody>
          {tableRows.map(([label1, value1, label2, value2], idx) => (
            <TableRow key={idx}>
              <TableCell style={{ fontWeight: "bold" }}>{label1}:</TableCell>
              <TableCell>{value1}</TableCell>
              <TableCell style={{ fontWeight: "bold" }}>{label2}:</TableCell>
              <TableCell>{value2}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedBulkUploadRecord;
